
































import { Component, Vue } from 'vue-property-decorator';
import { appName } from '@/env';
import { readLoginError, dispatchLogIn } from '@/store/main/accessors';

@Component
export default class Login extends Vue {
  public email: string = '';
  public password: string = '';
  public appName = appName;

  public get loginError() {
    return readLoginError(this.$store);
  }

  public submit() {
    dispatchLogIn(this.$store, {username: this.email, password: this.password});
  }
}
